import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import NoContent from 'Components/_common/NoContent'
import { ContestEventCard } from 'Components/ContestComponents/ContestEventCard'
import { TournamentEventCard } from 'Components/TournamentComponents/TournamentEventCard'
import WinnersContestAdaptor from 'Components/WinnersCard/WinnersContestAdaptor'
import PropTypes from 'prop-types'
import React from 'react'
import { Else, If, Then, When } from 'react-if'
import Button from 'Theme/Button'

import Skeleton from '../../Theme/Skeleton'

export const EventsCardList = ({
  title = '',
  noContentText,
  isFetched,
  isLoading,
  hasNextPage,
  fetchNextPage,
  data,
  isFinished = false,
}) => {
  const padding = isFinished ? 0 : '24px'
  const ContestCardComponent = isFinished ? WinnersContestAdaptor : ContestEventCard
  const hasData = data?.data.length

  return (
    <If condition={!hasData && !isFetched}>
      <Then>
        <Skeleton sx={{ height: 328, width: '100%', transform: 'none', marginTop: 3 }} />
      </Then>
      <Else>
        <If condition={hasData}>
          <Then>
            <Box>
              <When condition={!!title}>
                <Typography
                  variant="h3"
                  color="text.primary"
                  sx={{ margin: '32px 0 24px' }}
                >
                  {title}
                </Typography>
              </When>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                  '& .MuiCardContent-root': {
                    padding,
                    '&:last-child': { padding },
                  },
                }}
              >
                {data?.data.map((event) =>
                  event.tournament_id ? (
                    <TournamentEventCard
                      key={`tournament.${event.tournament_id}`}
                      event={data?.relations?.tournaments?.[event.tournament_id]}
                      disableStepper={isFinished}
                    />
                  ) : (
                    <ContestCardComponent
                      key={`contest.${event.contest_id}`}
                      event={data?.relations?.contests?.[event.contest_id]}
                      owner={data?.relations?.users?.[data?.relations?.contests?.[event.contest_id]?.owner_id]}
                      disableStepper={isFinished}
                    />
                  ),
                )}
              </Box>
              <If condition={isLoading}>
                <Then>
                  <Skeleton sx={{ height: 328, width: '100%', transform: 'none', marginTop: 3 }} />
                </Then>
                <Else>
                  <When condition={hasNextPage}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '24px',
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        disabled={!hasNextPage || isLoading}
                        onClick={fetchNextPage}
                      >
                        Load more
                      </Button>
                    </Box>
                  </When>
                </Else>
              </If>
            </Box>
          </Then>
          <Else>
            <When condition={!!noContentText}>
              <NoContent text={noContentText ?? ''} />
            </When>
          </Else>
        </If>
      </Else>
    </If>
  )
}

EventsCardList.propTypes = {
  title: PropTypes.string,
  noContentText: PropTypes.string,
  isFetched: PropTypes.bool,
  data: PropTypes.object,
  isFinished: PropTypes.bool,
}
